import { ScrollView, StyleSheet } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { SPACING } from 'constants/design-system';

import { AppSelectors } from 'store/App';
import { useAppSelector } from 'store/hooks';
import { HorizontalDivider, Spacer } from 'components';

import { CollapsibleSection } from './CollapsibleSection';
import { FilterSection } from './FilterSection';
import { InfoSection } from './InfoSection';
import { MenuSection } from './MenuSection';
import { MenuSectionMinimized } from './MenuSectionMinimized';
import { TabBarSection } from './TabBarSection';

export const SideBar = () => {
  const isSidebarMinimized = useAppSelector(
    AppSelectors.selectIsSidebarMinimized,
  );

  const safeAreaInsets = useSafeAreaInsets();

  return (
    <ScrollView
      style={[
        styles.container,
        { marginTop: safeAreaInsets.top + SPACING.theme[4] },
      ]}
      contentContainerStyle={styles.contentContainer}
      scrollEnabled
    >
      {!isSidebarMinimized ? <MenuSection /> : <MenuSectionMinimized />}
      <TabBarSection />
      <Spacer />
      <CollapsibleSection />
      <Spacer />
      <FilterSection />
      <HorizontalDivider style={{ marginVertical: 16, opacity: 0.8 }} />
      <InfoSection />
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  container: {
    marginVertical: 12,
  },
  contentContainer: {
    flexGrow: 1,
  },
});
